export default "__VITE_ASSET__B$XqHkHK__"